<template>
  <li class="chat-bubble">
    <div class="wrap" v-if="message.showTime">
      <span class="date">{{chatTime(message.sendtime)}}</span>
    </div>
    <div class="wrap content" :class="{reverse}">
      <div class="icon">
        <img class="head" :src="user_icon()">
      </div>
      <div class="context">
        <p v-if="message.msg_type==='Text'">{{ message.msg_content.text }}</p>
        <img v-else-if="message.msg_type==='Image'" class="photo" :src="photoPath">
        <div v-else-if="message.msg_type==='Audio'" class="audio-container" :style="{width: audio_width}">
          <p>{{message.msg_content.duration}}"</p>
          <span class="audio_default" :class="{audio_play: audioPlay}" @click="play_audio"></span>
          <audio ref="audio"><source ref="source" :src="audioPath" type="audio/mp3"></audio>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
  import {saveLocal, loadLocal} from 'common/js/store.js';
  import {mapState} from 'vuex';
  import {BASE_URL} from '@/common/im/config'
  import {parseChatTime} from '@/common/im/parse-time'
  export default {
    data () {
      return {
        imgprefix: (() => loadLocal('imgprefix', false))(),
        head_icon: require('./userhead.png'),
        image_icon: require('./image_error.png')
      }
    },
    props: ['message'],
    methods: {
      iconUrl(url){
        if (url === '') {
          return require('./userhead.png');
        } else {
          return this.imgprefix + url;
        }
      },
      user_icon(){
        let isSender = this.userID === this.message.sender_uid;
        let url = isSender ? this.userInfo.headImage : this.conversation.headImage;
        return this.iconUrl(url);
      },
      chatTime(time) {
        return parseChatTime(time);
      },
      play_audio() {
      	if (this.audioID === this.message.msg_id) {
          this.$store.commit('SET_AUDIO_MESSAGEID','')
        }else {
          this.$store.commit('SET_AUDIO_MESSAGEID',this.message.msg_id)
        }
      }
    },
    computed: {
      photoPath() {
        let src ='';
        let content = this.message.msg_content;
        if (content.preview) {
          src = content.preview;
        }else if (content.thumbnailRemotePath) {
          src = BASE_URL + '/' + content.thumbnailRemotePath;
        }else {
          src = this.image_icon;
        }
        return src;
      },
      audioPath() {
        return BASE_URL + '/' + this.message.msg_content.fileRemotePath;
      },
      audio_width() {
      	let min = 60;
      	let max = 180;
      	let seconds = this.message.msg_content.duration;
      	let width = 60;
      	if (seconds === 1) {
          width = min;
        }else if (seconds === 60){
      		width = max;
        }else {
        	width = seconds*2+min;
        	if (seconds > 60) {
            width = max;
          }
        }
        return width+'px'
      },
    	audioPlay() {
        let that = this;
        let audio = this.$refs.audio;
    		if (this.audioID === this.message.msg_id) {
    			if (audio && audio.paused) {
            // 监听播放完成事件
            audio.addEventListener('ended', function () {
              that.$store.commit('SET_AUDIO_MESSAGEID','')
            }, false);
            audio.play();
          }
        }else {
          if (audio && !audio.paused) {
            audio.removeEventListener('ended',null,false);
            audio.pause();
          }
        }
        return this.audioID === this.message.msg_id;
      },
      reverse () {
        return this.message.sender_uid === this.userID
      },
      ...mapState({
        userID:state=>state.conversation.currentUserID,
        userInfo:state=>state.conversation.userInfo,
        audioID:state=>state.conversation.audioMessageID,
        conversation:state=>state.conversation.currentConversation
      }),
    }
  }
</script>

<style lang="scss" scoped>

  $lineColor: #dfdfdf;
  $myColor: #a6ef5d;
  $otherColor: #fff;

  .chat-bubble {
    min-height: 42px;
    margin: 12px 8px;
    .wrap {
      margin: 8px 0;
      text-align: center;
      .date {
        padding: 4px 8px;
        color: #fff;
        font-size: 70%;
        background: #cecece;
        border-radius: 4px;
      }
      &.content {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-direction: row;
        .icon {
          margin-right: 8px;
          .head {
            width: 38px;
            height: 38px;
            border-radius: 19px;
          }
        }
        .context {
          position: relative;
          min-height: 22px;
          max-width: calc(100% - 120px);
          padding: 8px 12px;
          text-align: left;
          word-break: break-all;
          // 其他人 对话框背景
          border: 1px solid $lineColor;
          border-radius: 4px;
          background: $otherColor;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          flex-direction: row;
          .photo {
            max-width: 100px;
          }
          .audio-container {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            p {
              font-size: 15px;
            }
            .audio_default {
              display: inline-block;
              width: 30px;
              height: 30px;
              background-image: url("./audio_default_left.png");
            }
            .audio_play {
              background-image: url("./audio_play_left.png");
              animation: play steps(3,start) 1s infinite;
              -webkit-animation: play steps(3,start) 1s infinite;
              @-webkit-keyframes play {
                100% {background-position: -90px 0}
              }
            }
          }
          // 指向
          &::after {
            position: absolute;
            top: 14px;
            right: auto;
            bottom: auto;
            left: -4px;
            content: '';
            width: 8px;
            height: 8px;
            border: 1px solid $lineColor;
            border-top-color: transparent;
            border-right-color: transparent;
            background: $otherColor;
            transform: rotate(45deg);
          }
        }
      }
      // 反向   我的对话框
      &.reverse {
        justify-content: flex-end;
        .context {
          background: $myColor;
          .audio-container {
            flex-direction: row-reverse;
            .audio_default {
              background-image: url("./audio_default_right.png");
            }
            .audio_play {
              background-image: url("./audio_play_right.png");
              @-webkit-keyframes play {
                100% {background-position: 90px 0}
              }
            }
          }
        }
        .icon {
          order: 1;
          margin-right: 0;
          margin-left: 8px;
        }
        .context::after {
          left: auto;
          right: -5px;
          background: $myColor;
          transform: rotate(-135deg);
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/chat/components/bubble.vue